import { useContext, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { UserContext } from "../../App";
import CheckToken from "../../_Login/CheckToken";
import useInvoke from "../../Tools/Invoker";
import OilSave from "../Tools/OilerOilSave";
import toast from "react-hot-toast";

const OilDetails = () => {

    const [user, setUser] = useContext(UserContext);
    const navigate = useNavigate();
    const { id } = useParams();
    CheckToken(user["id"], user["token"]).then((result) => { if (!result) { setUser({}); navigate("/Login"); } });

    const [oil, setOil] = useState({});

    let response90 = useInvoke("WebApps", "90", { "@OilID": id });

    useEffect(() => {

        if (response90.data.payload != undefined) {
            let myData = JSON.parse(response90.data.payload).data;

            setOil(
                {
                    "oilID": myData[0][0],
                    "oilName": myData[0][1],
                    "oilViscosity": myData[0][2],
                    "description": myData[0][3]
                }
            )
        }

    }, [response90.data.payload]);

    const handleFormSubmit = (e) => {

        e.preventDefault();

        let oilid = parseInt(id);

        let oilName = document.getElementById("oilName").value;
        let oilViscosity = document.getElementById("oilViscosity").value;
        let oilDescription = document.getElementById("oilDescription").value;

        //console.log(oilid, oilName, oilDescription);

        OilSave(oilid, oilName, oilViscosity, oilDescription)
            .then((result) => {
                if (result.success) {
                    toast.success("Oil Updated");
                    navigate("/Oils");
                }
                else {
                    toast.error("Error Updating Oil");
                    console.log(result["message"]);
                }
            }
            );

    };

    document.title = "Oils";
    return (
        <>
            <div className="oils">
                {user["email"] != undefined &&
                    <>
                        {oil &&
                            <div className="container body-content" style={{ marginTop: "25px" }}>

                                <h2>Edit Oil</h2>

                                <form id="oilForm" noValidate="novalidate" autoComplete="off">

                                    <div className="form-group">
                                        <label htmlFor="oilID">Oil ID</label>
                                        <input className="form-control" id="oilID" name="oilID" type="text" defaultValue={oil["oilID"]} autoComplete="off" disabled/>
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="oilName">Oil Name</label>
                                        <input className="form-control" id="oilName" name="oilName" type="text" defaultValue={oil["oilName"]} autoComplete="off" />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="oilViscosity">Viscosity (cSt)</label>
                                        <input className="form-control" id="oilViscosity" name="oilViscosity" type="text" defaultValue={oil["oilViscosity"]} autoComplete="off" />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="oilDescription">Description</label>
                                        <textarea className="form-control" id="oilDescription" name="oilDescription" type="text" defaultValue={oil["description"]} autoComplete="off" />
                                    </div>

                                </form>
                                <Link to="/Oils" className="btn btn-default" style={{ marginRight: "4px" }}>Cancel</Link>
                                <button onClick={handleFormSubmit} className="btn btn-primary" style={{ marginRight: "4px" }}>Save</button>
                            </div>
                        }
                    </>
                }
            </div>
        </>
    );
}

export default OilDetails;